import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkSkeleton } from './uitk-skeleton.esm.js';

var UitkLineSkeleton = function (props) {
    var animation = props.animation, className = props.className, type = props.type;
    var wrapperClassNames = classNames("".concat(UitkSkeleton.baseClassName, "-line"), type && "".concat(UitkSkeleton.baseClassName, "-line-").concat(type), className);
    return React.createElement(UitkSkeleton, { className: wrapperClassNames, animation: animation });
};
UitkLineSkeleton.displayName = 'UitkLineSkeleton';
UitkLineSkeleton.defaultProps = {
    type: 'primary'
};

export { UitkLineSkeleton };
